import styled from "styled-components";

export const Container = styled.section`
  margin-top: 4rem;
  text-align: center;

  .trusted-heading {
    font-size: clamp(0.95rem, 1.4vw, 1.2rem);
    text-transform: uppercase;
    letter-spacing: 0.08em;
    opacity: 0.6;
    margin: 0 0 1.5rem;
  }

  .companies {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 2rem;
    flex-wrap: wrap;
    padding: 1.5rem 2rem;
    border-top: 1px solid rgba(128, 255, 120, 0.15);
    border-bottom: 1px solid rgba(128, 255, 120, 0.15);
  }

  .company-name {
    font-size: clamp(1.2rem, 2vw, 1.8rem);
    font-weight: 700;
    opacity: 0.6;
    letter-spacing: 0.05em;
    text-transform: uppercase;
  }
`;
